var render, staticRenderFns
import script from "./CustomFormDialog.vue?vue&type=script&lang=js"
export * from "./CustomFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c93d9c",
  null
  
)

export default component.exports